import useTrashStore from "src/store/api/useTrashStore";

 
export const useEmptyTrash = () => {
  const { responseMessage, isEmptyingTrash, errorEmptyingTrash, emptyTrash } = useTrashStore();

  return { responseMessage, isEmptyingTrash, errorEmptyingTrash, emptyTrash };
};
 